import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  NavLink,
} from "react-router-dom";

import Gravámenes from "../Pages/Permisos/Gravamenes";
import EstadoTramite from "../Pages/Estado/EstadoTramite";

const BodyContent = () => {
  return (
    <>
      <div className="container-fluid">
        <Routes>        
          <Route path="/gravamenes" element={ <Gravámenes /> }></Route>
          {/* <Route path="/consultar" element={ <EstadoTramite /> }></Route> */}

        </Routes>
      </div>
    </>
  );
};

export default BodyContent;
